/**
 * Reshapes a bundle-level promotional adjustment into the Promotion component's conditionalPromotion
 * contract so it can derive its sub-experience and messaging from the tag and reward amount.
 */

const buildRewardTier = (adjustment) => {
  // Adjustments carry no threshold, so model a per-item reward off the first unit. dollarOff wins
  // when both are present.
  const isPercentOff = !adjustment.dollarOff && adjustment.percentageOff != null;
  return {
    thresholdType: 'QUANTITY',
    minThresholdVal: 1,
    rewardLevel: 'ITEM',
    rewardType: isPercentOff ? 'PERCNTOFF' : 'AMTOFF',
    rewardVal: isPercentOff ? adjustment.percentageOff : adjustment.dollarOff
  };
};

const buildConditionalPromotion = (experienceTag) => (adjustment) => ({
  promotionId: adjustment.promoId,
  promotionTags: [experienceTag],
  reward: { tiers: [buildRewardTier(adjustment)] }
});

// Add a tag here to surface a new promotion.
const PROMOTION_TAG_BUILDERS = {
  BMSM: buildConditionalPromotion('BMSM'),
  BOGO: buildConditionalPromotion('BOGO')
};

const SUPPORTED_PROMOTION_TAGS = Object.keys(PROMOTION_TAG_BUILDERS);

export const getBundlePromotionData = (bundlePromotionalAdjustments) => {
  if (!bundlePromotionalAdjustments?.length) return null;

  const adjustment = bundlePromotionalAdjustments.find(
    (adj) => SUPPORTED_PROMOTION_TAGS.includes(adj?.promotionTag)
  );
  if (!adjustment) return null;

  const conditionalPromotion = PROMOTION_TAG_BUILDERS[adjustment.promotionTag](adjustment);
  if (!conditionalPromotion) return null;

  return {
    product: {
      pricing: {
        conditionalPromotions: [conditionalPromotion]
      }
    }
  };
};
